import $ from 'jquery';

$( window ).on( 'load', () => {
  $( '.nav-handle' ).on( 'click', () => {
    $( '.nav' ).toggleClass( 'open' )
    $( 'body' ).toggleClass( 'no-scroll' );
  } )

  $( '.menu .menu-item a' ).on( 'click', () => {
    $( '.nav' ).removeClass( 'open' );
    $( 'body' ).removeClass( 'no-scroll' );
  } )
}); 

if (  location.hash && !(location.hash.startsWith( '#!' ))  ){
  var id = $( location.hash );

  $( window ).on( 'load', function() {
    $( 'html,body' ).animate( { scrollTop: id.offset().top - 100 }, 600 )
  });
};

$( '#mc-embedded-subscribe' ).on( 'click', () => {
  dataLayer.push( { 'event': 'register_complete', 'value': 'complete' } );
})

$( '#wpcf7-f284-p380-o1 form' ).on( 'submit', () => {
  console.log('submitted')
  dataLayer.push( { 'event': 'contact_form', 'value': 'complete' } );
})